var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-with-buttons',{attrs:{"options":[ null, {text: 'N', value: 0, class: ['scoreButton']}, null,
                       {text: 'W', value: 3, class: ['scoreButton']}, null, {text: 'E', value: 1, class: ['scoreButton']},
                       null, {text: 'S', value: 2, class: ['scoreButton']}, null],"row-size":"3"},on:{"click":_vm.propagateClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }